<script>
  // import { mapState } from 'vuex'
  export default {
    name: 'AutocompleteSelect',
    props: ['form', 'placeholder', 'rules', 'field', 'label', 'items', 'dense', 'objkey', 'readonly', 'multiple'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field][this.objkey]
        },
        set(v) {
          this.$store.dispatch(`${ this.form }/SET_FIELD_OBJ`, { obj: this.field, key: this.objkey, value: v })
        },
      },
    },
  }
</script>

<template>
  <div class="ma-0 pa-0">
    <v-select
      :dense="dense"
      autocomplete="on"
      v-model="model"
      :placeholder="placeholder"
      :rules="rules"
      outlined
      @change="$emit('change', $event)"
      :label="label"
      :items="items"
      :readonly="readonly"
      :multiple="multiple"
    ></v-select>
  </div>
</template>

<style lang="scss" scoped>
  .v-input {
    height: 55px;
  }
</style>